"use client";
import { jsx, jsxs } from "react/jsx-runtime";
import { PrimaryButton } from "../../actions/buttons/PrimaryButton.js";
import "../../actions/buttons/SecondaryButton.js";
import "../../actions/buttons/SuccessButton.js";
import "../../actions/buttons/DangerButton.js";
import "../../actions/buttons/GhostButton.js";
import { TextButton } from "../../actions/buttons/TextButton.js";
import { IconButton } from "../../actions/buttons/IconButton.js";
import "../../actions/selectionControls/Checkbox.js";
import "../../actions/selectionControls/RadioButton.js";
import "../../actions/chips/ActionChip.js";
import "../../actions/chips/FilterChip.js";
import "../../actions/chips/TagChip.js";
import { Heading1Text } from "../../../foundation/typography/index.js";
import { useTranslation } from "../../../translations/index.js";
import { tokens } from "@gnist/themes/tokens.css.js";
import { Modal as Modal$1 } from "@mui/base";
import * as React from "react";
import { useState } from "react";
import { modalStyle, dialogRecipe, headerRowRecipe, contentContainerRecipe, actionRowRecipe, backdropStyle } from "./modal.css.js";
const hasScroll = (size, height) => {
  switch (size) {
    case "fullscreen":
      return true;
    case "large":
      return height > 654;
    case "medium":
      return height > 487;
    default:
      return height > 271;
  }
};
const Modal = React.forwardRef(function Modal2({ children, title, isOpen, handleClose, size = "medium", primaryAction, secondaryAction, action, backgroundColor = tokens.color.surface, ...rest }, ref) {
  var _a, _b;
  const text = useTranslation((t) => t.components.surfaces.modal);
  const [contentHeight, setContentHeight] = useState(0);
  const handleBackdropClick = (event) => {
    if (event.target === event.currentTarget) {
      handleClose();
    }
  };
  const Backdrop = () => jsx("div", { role: "presentation", className: backdropStyle, onClick: handleBackdropClick });
  return jsx(Modal$1, { className: modalStyle, open: isOpen, slots: { backdrop: Backdrop }, children: jsxs("div", { ref, className: dialogRecipe({ size }), ...rest, style: { backgroundColor }, children: [jsxs("div", { children: [jsxs("div", { className: headerRowRecipe({
    size,
    hasScroll: hasScroll(size, contentHeight)
  }), style: { backgroundColor }, children: [title ? jsx(Heading1Text, { children: title }) : jsx("span", { "aria-hidden": true }), jsx(IconButton, { icon: "close", label: text.dismissLabel, onClick: handleClose, disabled: (_a = primaryAction == null ? void 0 : primaryAction.loading) == null ? void 0 : _a.isLoading, autoFocus: true })] }), jsx("div", { ref: (element) => {
    if (element) {
      setContentHeight(element.offsetHeight);
    }
  }, className: contentContainerRecipe({
    size,
    hasScroll: hasScroll(size, contentHeight)
  }), children })] }), primaryAction || secondaryAction || action ? jsxs("div", { className: actionRowRecipe({
    size,
    hasScroll: hasScroll(size, contentHeight)
  }), style: { backgroundColor }, children: [primaryAction ? jsx(PrimaryButton, { ...primaryAction, children: primaryAction.label }) : null, secondaryAction ? jsx(TextButton, { ...secondaryAction, disabled: (_b = primaryAction == null ? void 0 : primaryAction.loading) == null ? void 0 : _b.isLoading, children: secondaryAction.label }) : null, action ? action : null] }) : null] }) });
});
export {
  Modal
};
